(function() {
  'use strict';

  angular
    .module('admin.tags.service', [])
    .factory('TagsService', TagsService);

  /** @ngInject */
  function TagsService($http, $q, API) {

    function list(start, limit){
        var defered = $q.defer();

        $http.get(API.API_URL + 'publisher/tags?start=' + start + '&limit=' + limit)
          .success(defered.resolve);

        return defered.promise;
    }

    function listAdmin(start, limit, sort){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/tags?start=' + start + '&limit=' + limit + '&sort=' + sort)
          .success(defered.resolve);

        return defered.promise;
    }

    function getId(id){
        var defered = $q.defer();

        $http.get(API.API_URL + 'tags/' + id)
          .success(defered.resolve);

        return defered.promise;
    }

    function save(model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/tags', model)
          .success(defered.resolve);

        return defered.promise;
    }

    function update(id, model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/tags/' + id, model)
          .success(defered.resolve);

        return defered.promise;
    }

    function remove(id){
        var defered = $q.defer();

        $http.delete(API.API_URL + 'admin/tags/' + id)
          .success(defered.resolve);

        return defered.promise;
    }

    function addTagChannel(parentId, model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'publisher/channels/' + parentId + '/tags', model)
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }
    function addTagPost(parentId, model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/posts/' + parentId + '/tags', model)
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    function addTagSet(parentId, model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'publisher/sets/' + parentId + '/tags', model)
          .success(defered.resolve);

        return defered.promise;
    }

    function addTagCollectible(parentId, model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'publisher/collectibles/' + parentId + '/tags', model)
          .success(defered.resolve);

        return defered.promise;
    }

    return{
        list: list,
        listAdmin: listAdmin,
        getId: getId,
        save: save,
        update: update,
        remove: remove,
        addTagChannel: addTagChannel,
        addTagPost: addTagPost,
        addTagSet: addTagSet,
        addTagCollectible: addTagCollectible
    };

  }

})();
